import React from "react";
import { CloseOutlined, ArrowBack } from "@mui/icons-material";
import type { GenericModalProps } from "./types";
import InfoTooltip from "../InfoTooltip/InfoTooltip";

const Modal: React.FC<GenericModalProps> = ({
	isOpen,
	onClose,
	title,
	icon,
	showCloseIcon = true,
	children,
	footer,
	width = "max-w-md",
	height = "auto",
	backgroundColor = "bg-white",
	rounded = "rounded-2xl",
	padding = "p-6",
	showBackIcon,
	onBack,
	className = "",
	isTooltipEnabled,
	tooltipText,
}) => {
	if (!isOpen) return null;

	return (
		<div
			className="fixed top-0 left-0 right-0 bottom-0 z-50 flex items-center justify-center bg-black/30 overflow-y-auto p-4 min-h-screen w-full"
			role="dialog"
			aria-modal="true"
			style={{ minHeight: "100dvh" }}>
			<div
				className={`${width} ${height} ${backgroundColor} ${rounded} ${padding} relative shadow-xl ${className} max-h-[90vh] overflow-hidden flex flex-col`}>
				{/* Header Row - only when title, icon or close icon is passed */}
				{(title || icon || showCloseIcon) && (
					<div className="flex justify-between items-start mb-4">
						<div className="flex items-center gap-2">
							{showBackIcon && (
								<button
									onClick={onBack}
									className="text-gray-600 hover:text-gray-900 transition-colors p-1 -ml-1 rounded-full bg-white">
									<ArrowBack className="w-5 h-5" />
								</button>
							)}
							{icon && <div className="text-xl text-accent">{icon}</div>}
							{title && (
								typeof title === "string" ? (
									<h2 className="text-lg font-semibold text-gray-900">{title}</h2>
								) : (
									title
								)
							)}
							{isTooltipEnabled && <InfoTooltip tooltip={tooltipText} />}
						</div>
						{showCloseIcon && (
							<button onClick={onClose} className="text-gray-400 hover:text-black">
								<CloseOutlined />
							</button>
						)}
					</div>
				)}

				{/* Modal Body - no extra top space when header is hidden */}
				<div className="overflow-y-auto flex-1 min-h-0">{children}</div>

				{/* Footer */}
				{footer && <div className="mt-6">{footer}</div>}
			</div>
		</div>
	);
};

export default Modal;
